import {Action} from '@ngrx/store';

export const GET_ALL_CANDIDATES = '[Candidates] Get All';
export const GET_ALL_CANDIDATES_SUCCESS = '[Candidates] Get All Success';
export const GET_ALL_CANDIDATES_ERROR = '[Candidates] Get All Error';

export const GET_CANDIDATE = '[Candidates] Get Candidate';
export const GET_CANDIDATE_SUCCESS = '[Candidates] Get Candidate Success';
export const GET_CANDIDATE_ERROR = '[Candidates] Get Candidate Error';

export const DELETE_CANDIDATE = '[Candidates] Delete Candidate';
export const DELETE_CANDIDATE_SUCCESS = '[Candidates] Delete Candidate Success';
export const DELETE_CANDIDATE_ERROR = '[Candidates] Delete Candidate Error';

export class GetAllCandidates implements Action {
  readonly type = GET_ALL_CANDIDATES;
}

export class GetAllCandidatesSuccess implements Action {
  readonly type = GET_ALL_CANDIDATES_SUCCESS;

  constructor(public payload: any) {
  }
}

export class GetAllCandidatesError implements Action {
  readonly type = GET_ALL_CANDIDATES_ERROR;

  constructor(public payload: any) {
  }
}

export class GetCandidate implements Action {
  readonly type = GET_CANDIDATE;

  constructor(public payload: any) {
  }
}

export class GetCandidateSuccess implements Action {
  readonly type = GET_CANDIDATE_SUCCESS;

  constructor(public payload: any) {
  }
}

export class GetCandidateError implements Action {
  readonly type = GET_CANDIDATE_ERROR;

  constructor(public payload: any) {
  }
}

export class DeleteCandidate implements Action {
  readonly type = DELETE_CANDIDATE;

  constructor(public payload: any) {
  }
}

export class DeleteCandidateSuccess implements Action {
  readonly type = DELETE_CANDIDATE_SUCCESS;
}

export class DeleteCandidateError implements Action {
  readonly type = DELETE_CANDIDATE_ERROR;

  constructor(public payload: any) {
  }
}

export type CandidateAction =
  GetAllCandidates
  | GetAllCandidatesSuccess
  | GetAllCandidatesError
  | GetCandidate
  | GetCandidateError
  | GetCandidateSuccess
  | DeleteCandidate
  | DeleteCandidateSuccess
  | DeleteCandidateError;



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/candidates/store/actions/candidate.action.ts